import ModalContainer from './modal-container'
import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'
import { DeleteSvgIcon } from '@/assets/svg'

interface DeleteModalProps {
  show: boolean
  hasCloseButton?: boolean
  handleClose: () => void
  modalClass?: string
  title?: string
  itemName?: string
  actionBtnLoading?: boolean
  disableActionBtn?: boolean
  handleDelete?: () => void
  cancelButtonClass?: string
  deleteButtonClass?: string
  iconClass?: string
  titleClass?: string
  buttonsContainerClass?: string
  icon?: React.ReactNode
}

export default function DeleteModal({
  show,
  hasCloseButton = false,
  handleClose,
  modalClass,
  title = 'Are you sure you want to delete',
  itemName = 'this item',
  actionBtnLoading,
  disableActionBtn,
  handleDelete,
  cancelButtonClass,
  deleteButtonClass,
  iconClass,
  titleClass,
  buttonsContainerClass,
  icon,
}: DeleteModalProps) {
  return (
    <ModalContainer
      show={show}
      handleClose={handleClose}
      modalClass={cn(
        'rounded-3xl py-10 px-6 bg-white md:w-[28.8rem] md:max-w-[30.8rem] lg:w-[28rem]',
        modalClass,
      )}
      hasCloseButton={hasCloseButton}
    >
      <section>
        <div className=''>
          <div className='text-center mb-8'>
            {/* Delete Icon */}
            <div className={cn('flex justify-center mb-6', iconClass)}>
              <div className='w-[200px h-[150px flex items-center justify-center'>
                {icon || (
                  <DeleteSvgIcon className='w-12 h-12 md:w-16 md:h-16 text-white bg-[#ED544E] rounded-full p-2.5' />
                )}
              </div>
            </div>

            {/* Confirmation Text */}
            <h3
              className={cn(
                'text-lg font-semibold text-gray-900 mb-2',
                titleClass,
              )}
            >
              {title} {itemName}?
            </h3>
          </div>

          {/* Action Buttons */}
          <div
            className={cn(
              'w-full flex justify-center gap-4',
              buttonsContainerClass,
            )}
          >
            <Button
              disabled={actionBtnLoading}
              className={cn(
                '!w-full rounded-xl p-3 px-16 mx-auto font-normal border',
                cancelButtonClass,
              )}
              onClick={handleClose}
              variant='ghost'
            >
              Cancel
            </Button>
            <Button
              loading={actionBtnLoading}
              disabled={disableActionBtn}
              className={cn(
                '!w-full rounded-xl p-3 px-16 mx-auto font-normal',
                deleteButtonClass,
              )}
              onClick={handleDelete}
              variant='destructive'
            >
              Delete
            </Button>
          </div>
        </div>
      </section>
    </ModalContainer>
  )
}
